import invoke from 'lodash/invoke';
import { Middleware } from 'redux';

import analyticsAgent from '@app/libs/analytics/agent';
import { KakaoPixelEventType } from '@app/libs/analytics/kakaoPixel/agent';
import {
  ANALYTICS_DATA_LAYER_VALUES_SET,
  ANALYTICS_DATA_LAYER_VALUES_TRIGGER,
  ANALYTICS_DATA_LAYER_VARIABLES_SET,
  ANALYTICS_EVENT_RECORD,
  ANALYTICS_USER_INITIALIZE,
  ANALYTICS_USER_SET,
} from '@app/store/actionTypes';
import { MultipleAnalyticsAction } from '@app/store/analytics/actions';
import { ANALYTICS } from '@app/store/metaKeys';

const eventServices = {
  default: () => null,
  facebook: ({
    type,
    name,
    parameter,
  }: {
    type: 'track' | 'trackCustom';
    name: string;
    parameter?: object; // eslint-disable-line @typescript-eslint/ban-types
  }) => analyticsAgent.facebook.trackEvent(type, name, parameter),
  ga: ({
    category,
    action,
    label,
    value,
  }: {
    category: string;
    action: string;
    label?: string;
    value?: number;
  }) => analyticsAgent.ga.recordEvent(category, action, label, value),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gtm: (params: { eventName: string; variables: Record<string, any> }) =>
    analyticsAgent.gtm.recordEvent(params),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gtmEcommerce: (params: { eventName: string; variables: Record<string, any> }) =>
    analyticsAgent.gtm.recordEcommerceEvent(params),
  kakaoPixel: (params: { eventType: KakaoPixelEventType; tag?: string }) => {
    analyticsAgent.kakaoPixel.recordEvent(params.eventType, params.tag);
  },
};

const dispatcher = ({ meta: { [ANALYTICS]: analyticsMeta } }: MultipleAnalyticsAction) => {
  analyticsMeta.forEach((action) => {
    switch (action.type) {
      case ANALYTICS_EVENT_RECORD:
        return invoke(eventServices, action.payload.service, action.payload);

      case ANALYTICS_USER_INITIALIZE:
        return analyticsAgent.gtm.initializeUser();

      case ANALYTICS_USER_SET:
        return analyticsAgent.gtm.setUser(action.payload);

      case ANALYTICS_DATA_LAYER_VARIABLES_SET:
        return analyticsAgent.gtm.setDataLayerVariables(action.payload.data);

      case ANALYTICS_DATA_LAYER_VALUES_SET:
        return analyticsAgent.gtm.setDataLayerValues(action.payload);

      case ANALYTICS_DATA_LAYER_VALUES_TRIGGER:
        return analyticsAgent.gtm.triggerDataLayerValues(action.payload.eventName);

      default:
        return null;
    }
  });
};

const analyticsMiddleware: Middleware = () => (next) => (action) => {
  if (action && action.meta && ANALYTICS in action.meta) {
    dispatcher(action);
  }

  return next(action);
};

export default analyticsMiddleware;
